import {axiosInstance} from './rest';

export async function getSearchClientIds(textSearch) {
    let text_search = '';
    if (textSearch !== undefined && textSearch !== null) {
        text_search = textSearch;
    }
    return axiosInstance.get(`administration/client-ids`, {params: {text_search}});
}
